export default {
  // App
  "appTitle": "Cronómetro y Temporizador multifunción",
  "siteIntro": "Crea y gestiona temporizadores y cronómetros personalizados con varios efectos visuales y notificaciones",
  
  // General
  "cancel": "Cancelar",
  "save": "Guardar",
  "start": "Iniciar",
  "pause": "Pausar",
  "stop": "Detener",
  "reset": "Reiniciar",
  "add": "Añadir",
  "edit": "Editar",
  "delete": "Eliminar",
  "confirm": "Confirmar",
  "close": "Cerrar",
  "back": "Volver",
  "submit": "Enviar",
  "timer": "Temporizador",
  "optional": "Opcional",
  "clickAgainToDelete": "Haz clic de nuevo para eliminar",
  "fullscreen": "Pantalla completa",
  "exitFullscreen": "Salir de pantalla completa",
  
  // Timer modes
  "countdown": "Cuenta regresiva",
  "stopwatch": "Cronómetro",
  
  // TimersContainer
  "myTimers": "Mis temporizadores",
  "addTimer": "Añadir temporizador",
  "noTimers": "Aún no hay temporizadores",
  "createFirstTimer": "Crea tu primer temporizador",
  
  // TimerForm
  "createTimer": "Crear temporizador",
  "editTimer": "Editar temporizador",
  "timerName": "Nombre del temporizador",
  "timerNamePlaceholder": "Introduce un nombre para el temporizador",
  "timerMode": "Modo del temporizador",
  "duration": "Duración",
  "hours": "Horas",
  "minutes": "Minutos",
  "seconds": "Segundos",
  "showMilliseconds": "Mostrar milisegundos",
  
  // Settings
  "settings": "Configuración",
  "darkMode": "Modo oscuro",
  "language": "Idioma",
  "notificationSound": "Sonido de notificación",
  "enableNotifications": "Activar notificaciones",
  "english": "Inglés",
  "chinese": "Chino",
  "spanish": "Español",
  "french": "Francés",
  "japanese": "Japonés",
  
  // Notification sounds
  "default": "Predeterminado",
  "bell": "Campana",
  "digital": "Digital",
  "chime": "Carillón",
  "none": "Ninguno",
  
  // Messages
  "timerComplete": "¡Temporizador completado!",
  
  // Effects
  "effect": "Efecto",
  "effectSettings": "Configuración de efectos",
  "effectType": "Tipo de efecto",
  "opacity": "Opacidad",
  "speed": "Velocidad",
  "primaryColor": "Color primario",
  "secondaryColor": "Color secundario",
  "circle": "Círculo",
  "wave": "Onda",
  "pulse": "Pulso",
  "particles": "Partículas",
  "gradient": "Degradado",
  "ripple": "Ondulación",
  
  // About page
  "about": "Acerca de",
  "aboutTitle": "Acerca de esta aplicación",
  "aboutIntroTitle": "Bienvenido al Cronómetro y Temporizador multifunción",
  "aboutIntroText": "Esta aplicación web te permite crear y gestionar múltiples temporizadores y cronómetros personalizables. Ya sea que necesites controlar el tiempo de ejercicio, cocina o períodos de trabajo, esta herramienta ofrece una solución flexible y fácil de usar.",
  
  "aboutFeaturesTitle": "Características principales",
  "aboutFeatureTimersTitle": "Temporizadores y cronómetros",
  "aboutFeatureTimersText": "Puedes crear temporizadores de cuenta regresiva y cronómetros. Los temporizadores de cuenta regresiva se pueden configurar en horas, minutos y segundos, mientras que los cronómetros miden el tiempo transcurrido desde cero.",
  
  "aboutFeatureNotificationsTitle": "Notificaciones",
  "aboutFeatureNotificationsText": "Recibe alertas visuales y sonoras cuando los temporizadores se completen. Puedes elegir entre varios sonidos de notificación o optar por una operación silenciosa.",
  
  "aboutFeatureEffectsTitle": "Efectos visuales",
  "aboutFeatureEffectsText": "Personaliza tus temporizadores con varios efectos visuales, incluyendo círculos, ondas, pulsos, partículas, degradados y más. Puedes ajustar la opacidad, velocidad y colores según tus preferencias.",
  
  "aboutFeatureShortcutsTitle": "Atajos de teclado",
  "aboutFeatureShortcutsText": "Controla tus temporizadores de manera eficiente con atajos de teclado para funciones de inicio, pausa, detención y reinicio.",
  
  "aboutFeatureLanguagesTitle": "Soporte multilingüe",
  "aboutFeatureLanguagesText": "Utiliza la aplicación en tu idioma preferido. Actualmente se admite inglés, chino, español, francés y japonés.",
  
  "aboutFeatureDarkModeTitle": "Modo oscuro",
  "aboutFeatureDarkModeText": "Cambia entre temas claros y oscuros para reducir la fatiga visual y ahorrar batería en dispositivos OLED.",
  
  "aboutHowToUseTitle": "Cómo usar",
  "aboutHowToCreateTitle": "Crear un temporizador",
  "aboutHowToCreateText": "Haz clic en el botón \"Añadir temporizador\", introduce un nombre, selecciona el modo del temporizador (cuenta regresiva o cronómetro), establece el tiempo (si es cuenta regresiva) y personaliza los efectos visuales. Haz clic en \"Guardar\" cuando hayas terminado.",
  
  "aboutHowToControlTitle": "Controlar temporizadores",
  "aboutHowToControlText": "Utiliza los botones de control para iniciar, pausar, detener y reiniciar tus temporizadores. También puedes cambiar al modo de pantalla completa para mayor visibilidad.",
  
  "aboutHowToCustomizeTitle": "Personalizar efectos",
  "aboutHowToCustomizeText": "Al crear o editar un temporizador, selecciona un tipo de efecto y utiliza los controles de opacidad, velocidad y color para ajustar su apariencia.",
  
  "aboutHowToManageTitle": "Gestionar temporizadores",
  "aboutHowToManageText": "Haz clic en el icono de editar para modificar un temporizador existente. Haz clic en el icono de eliminar dos veces para borrar un temporizador. Todos los temporizadores se guardan automáticamente y estarán disponibles cuando regreses.",
  
  "aboutProjectTitle": "Acerca del proyecto",
  "aboutProjectText": "Este proyecto está desarrollado como una aplicación web moderna utilizando React, TypeScript y varias bibliotecas para animaciones y gestión de estado.",
  
  "aboutVersionInfo": "Versión 1.0.0"
}; 